import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Field, ErrorMessage } from "formik";
import { FiEye, FiEyeOff } from "react-icons/fi";

const CMSFormInput = forwardRef((props, ref) => {
  const {
    name,
    label,
    form,
    smallDescription,
    required,
    onChange,
    autoFocus,
    hideError = false,
    placeholder,
    className,
    textHidden,
    disabled = false,
    type = "text",
    ...rest
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";

  const wrapperRef = React.useRef(null);

  // Expose scrollIntoView & focus to parent via ref
  useImperativeHandle(ref, () => ({
    scrollIntoView: () => {
      wrapperRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    focus: () => {
      wrapperRef.current?.querySelector("input")?.focus();
    },
  }));

  return (
    <div ref={wrapperRef} className="form-group w-full flex flex-col relative">
      {label &&
      <label
        htmlFor={name}
        className={`text-[19px] lg:text-21pt text-green text-nowrap ${
          textHidden ? "opacity-0" : ""
        } ${required ? "required" : "notRequired"} ${
          form.touched[name] && form.errors[name] ? "isInvalidText" : ""
        }`}
      >
        {label} <span className="text-16pt">{smallDescription}</span> {required  && <span className="text-20pt text-orange">*</span>}
      </label>}

      <div
        className={`relative ${className ? className : "2.5xl:max-w-[354px]"}`}
      >
        <Field
          name={name}
          autoFocus={autoFocus}
          placeholder={placeholder}
          onChange={onChange ? onChange : (e) => form.handleChange(e)}
          disabled={disabled}
          type={isPasswordField ? (showPassword ? "text" : "password") : type}
          className={`form-control w-full h-[56px] px-4 font-mono  rounded-[15px] border border-green mt-1 text-18pt
            focus:outline-none focus:ring-2 focus:ring-green focus:ring-opacity-50
            ${className ? className : "2.5xl:max-w-[354px]"}
            ${disabled ? "bg-gray-200 cursor-not-allowed" : ""}
            ${form.touched[name] && form.errors[name] ? "is-invalid" : ""}`}
          {...rest}
        />

        {isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            title={showPassword ? "Click to show value" : "Click to hide value"}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
          >
            {showPassword ? <FiEyeOff size={22} /> : <FiEye size={22} />}
          </button>
        )}
      </div>

      {!hideError && form.touched[name] && form.errors[name] && (
        <span id={`${name}-error`} className="errorMessage">
          <ErrorMessage name={name} />
        </span>
      )}
    </div>
  );
});

export default CMSFormInput;
